// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","container":"container-2kj7w","wrapper":"wrapper-1vUnG","arrow":"arrow-1LYIh","title":"title-2MOiP","close":"close-2uiOJ"};